/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 document.addEventListener('product:added', function(event) {
 var variant = event.detail.variant; // Get the variant that was added
 var quantity = event.detail.quantity; // Get the quantity that was added
   console.log(variant+'===='+quantity);
 tidioChatApi.track("shopify.add_to_cart");
 });
/*$(document).ready(function() {
  $('.enquiry-form__add-buttons').click(function(){ 
    $("#chaty-trigger-button-0").click();
  })
})*
  $(document).on('click', '.enquiry-form__add-buttons' , function() {
     $( ".csaas-i-trigger" ).trigger( "click" );
});
*/
$(document).ready(function() {
  $('.product-tags li').not(':hidden').last().addClass("nocomma");
  $('.my-bread li').not(':hidden').last().addClass("nocomma");
  $('#my0trig').click(function() {
        $( "#cta-open-yxzvkkhqq6" ).trigger( "click" );
    console.log('csas trigger');
    });
})
$('body').click(function(evt){    
       if(evt.target.id == ".collection__filter-group-list")
          return;
       //For descendants of menu_content being clicked, remove this check if you do not want to put constraint on descendants.
       if($(evt.target).closest('.collection__filter-group-list').length)
          return;             
    /*console.log('clicked outside');*/
  $('.collection__filter-group').find('button').attr('aria-expanded', 'false');
  $('.collection__filter-group').find('.collection__filter-collapsible').attr('aria-hidden', 'true');
  $('.collection-drawer__inner .collection__filter-group').find('.collection__filter-collapsible').attr('aria-hidden', 'true').css( "height", "0" );
  
});

$(".collection__filter-checkbox").click(function() {
    console.log('clicked the check');
  	$(this).closest('.collection__filter-group').find('button').attr('aria-expanded', 'false');
  	$(this).closest('.collection__filter-group').find('.collection__filter-collapsible').attr('aria-hidden', 'true');
	$('.collection-drawer__inner .collection__filter-group').find('.collection__filter-collapsible').attr('aria-hidden', 'true').css( "height", "0" );
});

